export default {
  buttonHolder: {
    display: 'flex',
    flexDirection: 'column',
    margin: '4em 0 0',
    alignItems: 'center',
    '& img': {
      marginBottom: '1.4em'
    },
    '& p': {
      margin: '0 0 24px'
    }
  }
}
